<template>
  <div :class="['vue-gradients']" :style="style">
    <vc-toolbar :color="primaryColor">
      <vc-toolbar-icon-left :icon="appIcon" :color="primaryColor" @click="$router.push({path: '/'})" />
      <vc-toolbar-title>{{ lang.appTitle }}</vc-toolbar-title>
      <vc-toolbar-controls-right>
        <vc-button color="transparent" icon-button tag="a" :to="link.to" target="_blank" v-for="(link, index) in links" :key="index">
          <vc-icon>{{ link.icon }}</vc-icon>
        </vc-button>
      </vc-toolbar-controls-right>
    </vc-toolbar>
    <vc-dialog :width="dialogWidth" :show="dialog" :color="primaryColor">
      <vc-dialog-header :close-button="false" :icon="appIcon">{{ lang.dialogTitle }}</vc-dialog-header>
      <vc-dialog-content :max-height="dialogMaxHeight">
        <vc-card>
          <vc-card-text>
            <vc-layout>
              <vc-col :span="12">
                <vc-radio-group :color="primaryColor" name="type" v-model="type">
                  <vc-radio v-for="(type, index) in types" :value="type" :key="index">{{ type.replace('-', ' ') }}</vc-radio>
                </vc-radio-group>
              </vc-col>
              <vc-col :span="12" v-if="type === 'linear-gradient'">
                <div :class="['align-center']">
                  <circle-slider :min="0" :max="360" :side="64" v-model="deg" circle-color="#666" progress-color="#000" knob-color="#000" />
                </div>
                <div :class="['align-center', 'degrees']">
                  <h3 :class="['subheading', 'ma-0', 'pa-0', 'ellipsis', 'font-grey', 'align-center']">{{ deg }}&deg;</h3>
                </div>
              </vc-col>
            </vc-layout>
          </vc-card-text>
        </vc-card>
        <vue-swatch :primary-color="primaryColor" :color="swatch" :index="index" :key="index" v-for="(swatch, index) in swatches" />
      </vc-dialog-content>
      <vc-dialog-footer>
        <vc-button :color="primaryColor" @click="copyGradient" v-tooltip="{text: lang.copyToClipboard}">
          <vc-icon>content_copy</vc-icon>
        </vc-button>
        <vc-button :color="primaryColor" @click="getPermanentLink" v-tooltip="{text: lang.getPermanentLink}">
          <vc-icon>insert_link</vc-icon>
        </vc-button>
        <vc-button :color="primaryColor" @click="addSwatch" v-tooltip="{text: lang.addSwatch}">
          <vc-icon>add</vc-icon>
        </vc-button>
      </vc-dialog-footer>
    </vc-dialog>
    <vc-notification name="notification" horizontal="left" />
    <vc-footer :color="primaryColor" fixed align="right">&copy; {{ year }} Created by
      <a href="https://wemakesites.net" target="_blank">Martin Ivanov</a> with <a href="https://vuecidity.wemakesites.net/" target="_blank">Vuecidity</a>,
      <a href="https://devstark-com.github.io/vue-circle-slider-demo/" target="_blank">VueCircleSlider</a> and <a href="https://vuejs.org/" target="_blank">VueJs</a></vc-footer>
    <vc-social-bar size="small" color="transparent" :button-color="primaryColor" :fixed="true" :items="social"/>
  </div>
</template>
<script>
import VueSwatch from '../vue-swatch'
import Social from '../../helpers/social'

export default {
  name: 'VueGradients',
  components: {
    VueSwatch
  },
  data () {
    return {
      social: Social,
      primaryColor: 'black',
      successColor: 'green',
      dialog: true,
      dialogWidth: '480px',
      dialogMaxHeight: '330px',
      appIcon: 'color_lens',
      links: [{
        to: 'https://wemakesites.net',
        icon: 'home'
      }, {
        to: 'https://vuecidity.wemakesites.net',
        icon: 'code'
      }, {
        to: 'https://martinivanov.net',
        icon: 'mdi-wordpress'
      }, {
        to: 'https://wemakesites.net/contact',
        icon: 'email'
      }],
      year: new Date().getFullYear(),
      lang: {
        dialogTitle: 'Color Swatches',
        appTitle: 'CSS Gradients',
        copyToClipboard: 'Copy',
        getPermanentLink: 'Get Permanent Link',
        addSwatch: 'Add Swatch',
        cannotCopy: '[VUE-GRADIENTS]: Can not copy gradient to clipboard',
        copySuccess: 'Gradient copied to clipboard!'
      },
      swatches: [],
      type: null,
      gradient: null,
      count: 3,
      deg: 45,
      types: [
        'linear-gradient',
        'radial-gradient'
      ]
    }
  },
  computed: {
    style () {
      return {
        background: this.gradient
      }
    }
  },
  watch: {
    deg () {
      this.doGradient()
    },
    type () {
      this.doGradient()
    },
    $route () {
      this.routeWatch(true)
    }
  },
  created () {
    const params = this.$route.params
    if (!params.type) {
      this.setRandomSwatches()
    } else {
      this.routeWatch(true)
    }
  },
  mounted () {
    this.$root.$on('swatch:input', (data) => {
      this.swatches[data.index] = data.swatch
      this.doGradient()
    })
    this.$root.$on('swatch:remove', (data) => {
      if (this.swatches.length > 2) {
        this.swatches.splice(data.index, 1)
        this.doGradient()
      }
    })
  },
  methods: {
    setRandomSwatches () {
      this.type = this.types[0]
      this.swatches = []
      for (let i = 0; i < this.count; i++) {
        this.swatches.push({
          color: this.random()
        })
      }
      this.doGradient()
    },
    routeWatch (doGradient) {
      const params = this.$route.params
      if (params.type) {
        const colors = params.colors.split(',')
        const swatches = []
        const options = JSON.parse(params.options)
        this.type = params.type
        colors.forEach(color => {
          swatches.push({
            color: `#${color}`
          })
        })
        this.swatches = swatches
        Object.keys(options).forEach(option => {
          this[option] = options[option]
        })
        if (doGradient) {
          this.doGradient()
        }
      } else {
        this.setRandomSwatches()
      }
    },
    getPermanentLink () {
      const swatches = []
      const options = [
        'deg'
      ]
      const urlOptions = {}
      this.swatches.forEach(swatch => {
        swatches.push(swatch.color.replace('#', ''))
      })
      options.forEach(option => {
        urlOptions[option] = this[option]
      })
      this.$router.push({
        path: `/${this.type}/${swatches.join(',')}/${JSON.stringify(urlOptions)}`
      })
    },
    addSwatch () {
      this.swatches.push({
        color: this.random()
      })
      this.doGradient()
    },
    random () {
      return `#${Math.random().toString(16).slice(2, 8)}`
    },
    addColor () {
      this.swatches.push({
        color: this.random()
      })
      this.doGradient()
    },
    copyGradient () {
      const lang = this.lang
      this.$copyText(this.gradient).then(() => {
        this.$root.$emit('vc:notification', {
          icon: 'content_copy',
          text: lang.copySuccess,
          color: this.successColor,
          dismissable: true,
          dark: true,
          name: 'notification'
        })
      }, () => {
        console.error(lang.cannotCopy)
      })
    },
    doGradient () {
      const gradient = []
      const type = this.type
      const deg = type === 'linear-gradient' ? `${this.deg}deg,` : ''
      this.swatches.forEach(swatch => {
        gradient.push(swatch.color)
      })
      this.gradient = `${type}(${deg} ${gradient.join(', ')})`
    }
  }
}
</script>
<style>
html,
body
{
  margin: 0;
  padding: 0;
  height: 100%;
}

*
{
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.vue-gradients
{
  height: 100vh;
}

.degrees
{
  margin-top: -44px;
}
</style>



// WEBPACK FOOTER //
// src/components/vue-gradients/index.vue